import React, { Component } from "react";
import PropTypes from "prop-types";
import SsnInput from "../../ssn-input/SsnInput";
import * as reactSpark from "react-spark";

const { Stack: { Item} } = reactSpark;

export const validation = {
  validateOn: ["blur"],
  required: true,
  validationRegex: /(^(?!000|9\d{2})\d{3}([-]{0,1})(?!00)\d{2}\1(?!0{4})\2\d{4}$)|^$/,
  message: {
    default: "Please enter a valid social security number"
  }
};

class SocialSecurity extends Component {
  constructor(props) {
    super(props);

    if (this.props.pattern) {
      validation.validationRegex = this.props.pattern;
    }
  }

  static cleanValue(value) {
    return value.replace(/\D/g, "");
  }

  static defaultProps = {
    value: ""
  };

  static propTypes = {
    value: PropTypes.string
  };

  render() {
    const {
        id,
        name,
        label,
        disabled,
        value,
        ...props
    } = this.props;

    return (
      <Item breakpoint="tiny" width="fourth">
        <SsnInput
          id={id || "socialSecurity"}
          name={name || "socialSecurity"}
          type="password"
          label={label}
          disabled={disabled}
          validation={validation}
          value={value}
          {...props}
        />
      </Item>
    );
  }
}

export default SocialSecurity;
